import React from "react";
export default function About() {

    return (
        <section id="about">
            <header className="section-header">
                <h2>About</h2>
                <p>discoform provides front-end development services to clients who are concerned with simplicity, SEO, page-speed, semantic markup, and accessibility.</p>
            </header>
            <div className="section-content">
                <h3>Our Tools</h3>
                <p>We're fully onboard with <a href="https://jamstack.org/" target="_blank" rel="noopener noreferrer">the Jamstack approach</a> to web development and deployment. We typically make the following technology recommendations to our clients:</p>
                <h4>Site Generators</h4>
                <ul>
                    <li><a href="https://jekyllrb.com/" target="_blank" rel="noopener noreferrer">Jekyll</a></li>
                    <li><a href="https://www.gatsbyjs.com/" target="_blank" rel="noopener noreferrer">Gatsby</a></li>
                    <li><a href="https://www.11ty.dev/" target="_blank" rel="noopener noreferrer">Eleventy</a></li>
                </ul>
                <h4>Content Management Systems</h4>
                <ul>
                    <li><a href="https://www.netlifycms.org/" target="_blank" rel="noopener noreferrer">Netlify CMS</a></li>
                    <li><a href="https://www.sanity.io" target="_blank" rel="noopener noreferrer">Sanity</a></li>
                    <li><a href="https://ghost.org/" target="_blank" rel="noopener noreferrer">Ghost</a></li>
                </ul>
                <h4>Hosting</h4>
                <ul>
                    <li><a href="https://www.netlify.com/" target="_blank" rel="noopener noreferrer">Netlify</a></li>
                    <li><a href="https://vercel.com/" target="_blank" rel="noopener noreferrer">Vercel</a></li>
                    <li><a href="https://pages.github.com" target="_blank" rel="noopener noreferrer">GitHub Pages</a></li>
                </ul>
            </div>
        </section>
    );
}



// WEBPACK FOOTER //
// ./src/components/About.js